export default {
      id: "icon_plus-usage",
      viewBox: "0 0 26 26",
      url: __webpack_public_path__ + "sprite.svg#icon_plus",
      toString: function () {
        return this.url;
      }
    }